module.exports = __webpack_public_path__ + "static/media/entranceMobile.53413fba.png";